import React, { useState } from 'react';

import { IconSwitcher } from '@src/components/Icon';
import EyeOutlineIcon from '@src/components/Icon/EyeOutlineIcon';
import EyeOutlineSlashIcon from '@src/components/Icon/EyeOutlineSlashIcon';
import { themeStyle, useNewThemeActive } from '@src/theming';

import { PasswordInputProps } from './types';

export const PasswordInput: React.FC<PasswordInputProps> = ({
  error,
  onTogglePasswordVisibility,
  theme,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isNewThemeActive = useNewThemeActive();

  const _theme = isNewThemeActive
    ? { color: error ? themeStyle.redMain : themeStyle.varInkMain }
    : { color: error ? theme.colorError : themeStyle.varBrandMedium };

  const togglePasswordVisibility = (): void => {
    setShowPassword((previous) => {
      onTogglePasswordVisibility?.(previous);
      return !previous;
    });
  };

  return (
    <button
      aria-label={showPassword ? 'Hide password' : 'Show password'}
      style={{ cursor: 'pointer' }}
      type="button"
      onClick={togglePasswordVisibility}
    >
      <IconSwitcher
        height="13px"
        icon={showPassword ? EyeOutlineSlashIcon : EyeOutlineIcon}
        theme={_theme}
      />
    </button>
  );
};
